
/**
 * @file demo store
 * 这是一个 san-store 版本的示例
 * 1. ui 组件只关心自己的状态（data）不关心外面是否有 store
 *      ui 组件通过自定义事件跟父组件通信，https://baidu.github.io/san/tutorial/event/#%E8%87%AA%E5%AE%9A%E4%B9%89%E4%BA%8B%E4%BB%B6
 * 2. store 中调用 service，其他地方不得调用
 * 3. 容器组件引入 store，connect 之后通过 actions直接调用 store 的 action
 * 3. 容器如果需要获取store某个值的变化，使用 watch 功能，参考loading 效果实现清空 content 内容
 */
import app from '@/lib/App';
import {connect} from '@/lib/Store';
import '@/lib/utils/patchSan';
import {keyZipObject} from '@/lib/utils/keyZipObject';
import {initBaseLog} from '@/lib/utils/thunder';
import {initSpy, sendPerfLog} from '@/lib/utils/spy';
import AppComponent from './containers/app';
import initStore from './store';

const initPage = data => {
    let store = initStore(data);

    initBaseLog(data);
    initSpy();

    const keyMap = keyZipObject(Object.keys(store.raw));

    // // 如果非 newspage 页面或者说反解失败，则用纯前端渲染渲染方案，先渲染 SSRContent 部分
    const renderContent = () => {
        try {
            app(AppComponent, '#ssr-content-wrapper', {data, append: false});
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
        const ssrContentWrapper = document.getElementById('ssr-content-wrapper');
        ssrContentWrapper.style.display = 'block';
    };

    connect.san(keyMap)(AppComponent);

    const ssrEl = document.getElementById('ssr-content');
    if (ssrEl) {
        // SSR 反解
        /* eslint-disable no-new */
        const params = {el: ssrEl, data: data};
        try {
            new AppComponent(params);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            renderContent();
        }
    }
    else {
        renderContent();
    }
};

window.init = () => {
    initPage(window.jsonData);

    document.addEventListener('DOMContentLoaded', () => {
        window.domReadyTime = Date.now();
    }, false);
    window.onload = () => {
        window.loadedTime = Date.now();
        sendPerfLog();
    };
    try {
        // BC透传文章标识
        const author = window.jsonData.bsData.superlanding[0];
        window.isBC = author.itemData.sections.some(subContent => !!subContent.data_html);
    }
    catch (err) {
        /* eslint-disable no-console */
        console.error(err);
    }
};

window.init();
